// src/services/logService.js
// Fetches system logs from the admin API.

import { AUTH } from './config';

const getAuthHeaders = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${localStorage.getItem('authToken') || ''}`,
});

const BASE = AUTH.BASE_URL.replace('/auth', '/logs');

const handleRes = async (res) => {
  const json = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(json.message || `HTTP ${res.status}`);
  return json;
};

/**
 * Fetch paginated logs.
 * @param {object} filters
 * @param {string} [filters.level]     info | warning | error | critical
 * @param {string} [filters.category]  auth | user_mgmt | device | gateway | api_key | system | payment | webhook
 * @param {string} [filters.q]         free-text search
 * @param {string} [filters.from]      ISO date string
 * @param {string} [filters.to]        ISO date string
 * @param {number} [filters.page]
 * @param {number} [filters.limit]
 */
export const fetchLogs = async (filters = {}) => {
  const p = new URLSearchParams();
  if (filters.level)    p.set('level',    filters.level);
  if (filters.category) p.set('category', filters.category);
  if (filters.q)        p.set('q',        filters.q);
  if (filters.from)     p.set('from',     filters.from);
  if (filters.to)       p.set('to',       filters.to);
  p.set('page',  filters.page  || 1);
  p.set('limit', filters.limit || 50);

  return handleRes(await fetch(`${BASE}?${p}`, { headers: getAuthHeaders() }));
};

/** Fetch counts-by-level/category summary for the dashboard strip. */
export const fetchLogStats = async () =>
  handleRes(await fetch(`${BASE}/stats`, { headers: getAuthHeaders() }));
